'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FLINT } from 'HubStyleTokens/colors';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIIconButton = styled(UIIconButton).withConfig({
  displayName: "MessageExpandButton__StyledUIIconButton",
  componentId: "sc-5cb1rb-0"
})(["padding-bottom:2px;margin-left:-5px;"]);
const MessageExpandButton = ({
  isMessageReplyLoading,
  onClick
}) => {
  return isMessageReplyLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsx(StyledUIIconButton, {
    style: {
      paddingBottom: '2px'
    },
    placement: "top",
    use: "link",
    className: "m-top-4 selenium-test-marker-message-expand-btn",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "ellipses",
      size: "medium",
      color: FLINT
    })
  });
};
MessageExpandButton.displayName = 'MessageExpandButton';
MessageExpandButton.propTypes = {
  isMessageReplyLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default MessageExpandButton;